import { useEffect, useMemo, useState } from 'react';
import { fetchItemOutcomes, type ItemOutcome } from '@/lib/items/itemOutcomes';

/** Outcomes for a set of items, re-read when the set (or `refreshKey`) changes. */
export function useItemOutcomes(itemIds: readonly string[], refreshKey: unknown = 0) {
  const key = useMemo(() => Array.from(new Set(itemIds)).sort().join(','), [itemIds]);
  const [outcomes, setOutcomes] = useState<Map<string, ItemOutcome>>(new Map());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const ids = key ? key.split(',') : [];
    if (ids.length === 0) {
      setOutcomes(new Map());
      return;
    }
    setLoading(true);
    fetchItemOutcomes(ids)
      .then((m) => { if (!cancelled) { setOutcomes(m); setError(null); } })
      .catch((e: unknown) => { if (!cancelled) setError(e instanceof Error ? e.message : String(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [key, refreshKey]);

  return { outcomes, loading, error };
}
